module.exports = __webpack_public_path__ + "static/media/countdown.9ef6dfda.jpg";